import React from 'react'
import '../CSS/About.css'


export default function About() {
  return (
    <div id='about' style={{minHeight:85+'vh',maxWidth:'1200px',margin:'0 auto'}}>
        <p>
        Welcome to Campus Connect, the online platform that connects college seniors with their junior counterparts, allowing them to buy and sell items within their own college community.</p><p>
        We understand the importance of making the most out of your college experience, and that often involves purchasing items from fellow students, whether it's textbooks, furniture, electronics, or clothing. That's why we created Campus Connect - to make it easy for seniors to connect with juniors and sell their items within their own college community.
        </p><p>
Our platform is safe, user-friendly, and designed with students in mind. It's a great resource for seniors who want to sell their items to juniors who are looking for quality, affordable products within their own campus.
</p><p>
At Campus Connect, we value transparency, authenticity, and security. We take all the necessary measures to ensure that our users' personal information and financial transactions are secure, and that our platform is free of spam and fraudulent activity.
</p><p>
Our team is committed to making the buying and selling experience as seamless as possible. We offer a range of features to help our users find the products they need, including a search function, categories, and filters. And if you have any questions or concerns, our customer service team is always available to help.
</p><p>
Join the Campus Connect community today and start buying and selling with fellow students in your college community. Make the most out of your college experience with Campus Connect.
        </p>
    </div>
  )
}
